import { cfgThemePath, stateUi } from '@infinitro/config';
import { Verbiage } from '@infinitro/content';
import { get } from 'svelte/store';
export const getVerbiageKey = (key) => {
    const usePrefixedVerbiageKeys = get(stateUi).vip.usePrefixedVerbiageKeys ?? false;
    const result = usePrefixedVerbiageKeys
        ? `${cfgThemePath()}_${key}`
        : key;
    return result;
};
